export default __webpack_public_path__ + "static/roadmap-2-bf89b5c3fce87939b4b4df534e43f3b2.jpg";